const parse_array = (str: string, index: number) => {
  console.log({ str, index });

  let array = new Array<any>();
  let current_index = index;
  let current_value: string | null = null;
  let start = false;

  while (current_index < str.length) {
    const current_char = str.charAt(current_index);
    console.log({ current_index, current_char, current_value });

    current_index++;

    if (!start && current_char !== "[") return null;
    if (!start && current_char === "[") {
      start = true;
      continue;
    }

    if (current_value === null && current_char === " ") continue;

    if (current_char === "]") {
      if (current_value !== null) array.push(current_value);
      return { object: array, length: current_index };
    }

    if (current_char === "," && current_value !== null) {
      array.push(current_value);
      current_value = null;
      continue;
    }

    if (current_value === null) {
      current_value = "";
    }

    current_value += current_char;
  }

  return { object: null, length: 0 };
};

const parse_object = (str: string, index: number) => {
  if (!str.startsWith("{")) return null;

  console.log({ str, index });

  let object: Record<string, any> = {};

  let start = false;
  let in_value = false;
  let in_key = false;
  let current_key: string | null = null;
  let current_value: string | null = null;
  let wait_for_comma = false;

  let current_index = index;
  while (current_index < str.length) {
    const current_char = str.charAt(current_index);
    const prev_char = current_index > 0 ? str.charAt(current_index - 1) : "";

    current_index++;

    if (wait_for_comma && current_char === ",") {
      wait_for_comma = false;
      in_value = false;
      in_key = false;
      current_key = null;
      current_value = null;
      continue;
    }

    if (wait_for_comma && current_char === "}") {
      return { object, length: current_index - index };
    }

    if (!start && current_char !== "{") return null;
    if (!start && current_char === "{") {
      start = true;
      continue;
    }

    if (start && !in_key && !in_value && current_char === "}")
      return { object, length: current_index - index };

    // start new key and strip leading zeroes
    if (!in_key && current_key === null && !in_value && current_char !== " ") {
      in_key = true;
      current_key = "";
    }

    // find end of key
    if (in_key && current_char === ":") {
      in_key = false;
      in_value = true;
      current_value = "";
      continue;
    }

    if (in_key) {
      current_key += current_char;
    }

    if (current_key === null) continue;

    // value stuff

    if (in_value && current_value?.length === 0 && current_char === " ")
      continue;

    // parse object
    if (in_value && current_char === "{") {
      let val = parse_object(str, current_index - 1);

      if (val !== null) {
        object[current_key] = val.object;
        current_index += val.length - 1;
        in_value = false;
        in_key = false;
        wait_for_comma = true;
        continue;
      } else {
        return null;
      }
    }

    // parse array
    if (in_value && current_char === "[") {
      let val = parse_array(str, current_index - 1);
      if (val !== null) {
        object[current_key] = val.object;
        current_index += val.length - 1;
        in_value = false;
        in_key = false;
        wait_for_comma = true;
      } else {
        return null;
      }
    }

    if (in_value && current_char === "}") {
      object[current_key] = current_value;
      in_value = false;
      in_key = false;
      current_key = null;
      current_value = null;
      return { object, length: current_index - index };
    }

    // parse anything else
    if (in_value && current_char === "," && prev_char !== "\\") {
      object[current_key] = current_value;
      in_value = false;
      in_key = false;
      current_key = null;
      current_value = null;
    }

    if (in_value) {
      current_value += current_char;
    }
  }
  return null;
};

export const parse_rjson = (str: string) => {
  if (str.startsWith("[")) return parse_array(str, 0)?.object;
  if (str.startsWith("{")) return parse_object(str, 0)?.object;
  return null;
};
